import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// transmissions — ประเภทเกียร์
// ============================================================================
export const transmissions = sqliteTable("fleet_transmissions", {
  id: text("id").primaryKey(), // ULID
  name: text("name").notNull(),
  nameTh: text("name_th"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type Transmission = typeof transmissions.$inferSelect;
export type NewTransmission = typeof transmissions.$inferInsert;
